import React, { useEffect, useState } from 'react'
import { getUserSelector } from '../../../../../redux/reducers/reducerSlices/UserReducer';
import { useSelector } from 'react-redux';
import { getCountryCode, getMobileNumber } from '../../../../Assests/Utility';
import CSCESPRO from './spro/CSCESPRO';
import CSCEIMS from './ims/CSCEIMS';

const ChatSupport = (props) => {

  const user = useSelector(getUserSelector);
  const { userAccountDetails, cu_id, userType, selectedWarehouse } = user;

  const [url, setUrl] = useState("");
  const [apptype, setAppType] = useState("")

  useEffect(() => {
    if (userType && userType?.toUpperCase() === 'CARRIER') {
      setAppType('spro')

    } else if (userType && userType?.toUpperCase() === 'USER' && selectedWarehouse && selectedWarehouse?.RoleName?.toUpperCase() === 'WHADMIN') {
      setAppType('ims')
    }

  }, [userAccountDetails]);

  useEffect(() => {
    if (userAccountDetails) {
      const { CUID, Email, FirstName, LastName, Phone } =
        userAccountDetails;
      const phone = getMobileNumber(Phone);
      const countryCode = getCountryCode(Phone);
      let tempURL = null;
      if (apptype === 'spro') {
        tempURL = `${process.env.REACT_APP_CSCE_USER_BASEURL}?type=user&cuid=${CUID}&email=${Email}&firstName=${FirstName}&lastName=${LastName}&phone=${phone}&countryCode=${countryCode}&apptype=spro&supporttype=normal`;
      } else if (apptype === 'ims') {
        tempURL = `${process.env.REACT_APP_CSCE_USER_BASEURL}?type=user&cuid=${CUID}&email=${Email}&firstName=${FirstName}&lastName=${LastName}&phone=${phone}&countryCode=${countryCode}&apptype=ims&supporttype=normal`;
      } else {
        console.log('No Apptype found')
      }
      setUrl(tempURL);
    }
  }, [apptype])

  return (
    apptype === 'spro' ? (
      <CSCESPRO url={ url} {...props} />) : 
      (
       <CSCEIMS url={ url} {...props}/>
      )
  );
}

export default ChatSupport